import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Layout from "../Layout/Layout";
import VcoiRoutes from "../../Common/VCOIRoutes/VcoiRoutes";
import DcoiRoutes from "../../Common/DCOIRoutes/DcoiRoutes";
import AppSelectorPage from "../AppSelector/AppSelector";

// Protected Route
const ProtectedRoute = ({ element, hasPermission }) => {
  if (!hasPermission) {
    return <Navigate to="/" replace />;
  }
  return element;
};

const Wrapper = () => {
  const userPermissions = {
  VCOI: window.IsVendor,
  DCOI: window?.IsDcoi,
  };

  return (
    <Layout>
      <Routes>
        <Route
          path="/"
          element={
            <AppSelectorPage
              permissions={userPermissions}
            />
          }
        />
        {/* VCOI Route */}
        <Route
          path="/app-vcoi/*"
          element={
            <ProtectedRoute
              element={<VcoiRoutes />}
              hasPermission={userPermissions.VCOI}
            />
          }
        />
        {/* DCOI Route */}
        <Route
          path="/app-dcoi/*"
          element={
            <ProtectedRoute
              element={<DcoiRoutes />}
              hasPermission={userPermissions.DCOI}
            />
          }
        />
      </Routes>
    </Layout>
  );
};

export default Wrapper;
